export default {"src":"/_next/static/media/dg_inaugral_banner.56d57733.svg","height":1058,"width":1056,"blurWidth":0,"blurHeight":0};